Wee.fn.make('search', {
	init: function() {
		var $priv = this.$private;

		$priv.initEvents();

		$('ref:searchForm').attr('aria-hidden', true);
	},

	unload: function() {
		$.events.off(false, '.search');
	}
}, {

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$('ref:searchCategory').on('click.search', function(e, el) {
			$.history.go({
				path: Wee.routes.uri().path + scope.getQuery($(el).text().toLowerCase())
			});
		});
	},

	/**
	 * Get query string to determine what results tab to activate
	 * @param  {string} category User-selected category tab
	 * @private
	 */
	getQuery: function(category) {
		var routeQuery = Wee.routes.uri().query;

		routeQuery.category = category;

		return '?' + $.serialize(routeQuery);
	}
});